<template>
  <div>
    <carouselMobile
      v-if="isMobileScreen"
      v-bind="$attrs" />
    <carouselPC
      v-else
      v-bind="$attrs" />
  </div>
</template>
<script>
export default {
  name: "ylHomeCarousel",
  components: {
    carouselMobile: () => import("./components/mobile.vue"),
    carouselPC: () => import("./components/pc.vue"),
  },
  data() {
    return {};
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {},
  methods: {},
};
</script>
<style scoped lang="scss"></style>
